// extracted by mini-css-extract-plugin
module.exports = {"h3":"card_h3__3g0wg","image":"card_image__1PVzO","contenedor":"card_contenedor__1hJFq","conten2":"card_conten2__1oK5b"};